// extracted by mini-css-extract-plugin
module.exports = {"over_view":"CustomerOverView_over_view_tMJbo","viewer":"CustomerOverView_viewer_3pdZk","explain":"CustomerOverView_explain_2-BpZ","border":"CustomerOverView_border_kt4M_"};